module.exports = "<div class=c-payment__request> <div id=payment-request-button></div> <p class=c-payment__request__text><span>Or enter your payment details below</span></p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/journey-ui/payment/views/payment.requestButton.html
// module id = 464
// module chunks = 0